import React from 'react';
import { AdminHome } from '../pages/admin/AdminHome';
import { ApplyList } from '../pages/admin/ApplyList';
import { ClinicList } from '../pages/admin/ClinicList';
const routes = [
    {
        path: '/',
        exact: true,
        children: React.createElement(AdminHome, null),
        component: AdminHome,
    },
    {
        path: '/apply_list',
        exact: true,
        children: React.createElement(ApplyList, null),
        component: ApplyList,
    },
    {
        path: '/clinic_list',
        exact: true,
        children: React.createElement(ClinicList, null),
        component: ClinicList,
    },
];
export default routes;
